import { IReference } from './IReference';
import { ReferencePathDirection } from './IReferencePath';

/**
 * Se la reference è ottenuta come _figlia_ (`Child`) del nodo passato come
 * padre, restituisce l'indice della reference nel path.
 * ALtrimenti, restituisce `-1`.
 */
export function findIndexReferenceChildOf(
  reference: IReference,
  parentCode: string,
) {
  const index = reference.path.findIndex(
    p => p.direction === ReferencePathDirection.Child && p.code === parentCode,
  );

  return index;
}
